import { getAPI, postAPI, putAPI } from '../../api/apis';
import { REACT_APP_CANDIDATE, REACT_APP_CANDIDATE_FREELANCER } from '../../utils/common';

export async function updateAvailablity(data: any){
    const availablity = putAPI( REACT_APP_CANDIDATE_FREELANCER + `/availability`, data)
    return availablity
}


export async function getDetails(Id: string | null){
    const Details = getAPI( REACT_APP_CANDIDATE + `/candidates/${Id}`)
    return Details
}

